/**
 * The value a Shape control (and a `showWhen` condition) reads for a parameter key: a family's
 * `design.params` entry, or a grid's top-level design key. `base` is read normalised, so a design
 * that only carries a plinth height reads as `plinth` (src/families/base.ts `baseOf`).
 */
import type { Design } from '@/domain/schemas';
import { baseOf, type BaseParams } from '@/families/base';
import { gridBaseOf } from '@/families/grid-bookcase/design';

export function paramValue(d: Design, key: string, bays?: number): unknown {
  if (key === 'bays' && bays !== undefined) return bays;
  if (d.params && !['W', 'H', 'D'].includes(key)) {
    if (key === 'base') return baseOf(d.params as BaseParams).kind;
    return d.params[key];
  }
  if (key === 'base') return gridBaseOf(d).kind;
  return (d as unknown as Record<string, unknown>)[key];
}
